module.exports = __webpack_public_path__ + "static/media/StartScreenImage.328cb2cc.jpg";